// Suburb landing page data — every entry becomes a page at /pilates-near/[slug].
// Distances are approximate driving distance from the studio (5/49 Batesford Rd, Chadstone VIC 3148).
// Each page is optimised for AI answer engines (ChatGPT / Gemini / Perplexity / Grok) and
// Google local pack queries like "pilates near <suburb>".

export const NEARBY_SUBURBS = [
  {
    slug: "malvern-east",
    suburb: "Malvern East",
    postcode: "3145",
    distanceKm: 2.5,
    driveMinutes: 6,
    intro:
      "Malvern East locals are just a five-minute drive from Passion Pilates, our 9-bed boutique reformer studio on Batesford Road. If you're searching for reformer Pilates near Malvern East, this is the closest boutique studio with morning, midday and evening classes seven days a week.",
    localHooks: [
      "Two minutes from Central Park and Waverley Road cafés",
      "Free on-site parking — no meters, no fuss",
      "Direct route via Waverley Road or Dandenong Road",
      "Trusted by Malvern East mums for our Tuesday & Thursday Mums & Bubs class",
    ],
    landmarks: [
      "Central Park Malvern East",
      "Chadstone Shopping Centre",
      "Holmesglen Station",
      "Waverley Road strip",
    ],
    nearbyStations: ["Holmesglen", "East Malvern"],
    keywords: [
      "reformer pilates malvern east",
      "pilates near malvern east",
      "best pilates malvern east",
      "boutique pilates malvern east",
      "malvern east reformer studio",
    ],
  },
  {
    slug: "oakleigh",
    suburb: "Oakleigh",
    postcode: "3166",
    distanceKm: 2.8,
    driveMinutes: 7,
    intro:
      "Oakleigh is only a seven-minute drive from Passion Pilates. If you're looking for a reformer Pilates studio near Oakleigh — with genuine 45-minute programming (not 55-minute cardio classes marketed as reformer) — you've found it.",
    localHooks: [
      "Straight up Warrigal Road from Eaton Mall",
      "Close-knit, family-friendly community — perfect for Mums & Bubs",
      "Corporate group hire available for Oakleigh businesses",
      "Bulk 20-Class Packs — great for shift workers and hospitality staff",
    ],
    landmarks: [
      "Eaton Mall (Greek Precinct)",
      "Oakleigh Station",
      "Oakleigh Recreation Centre",
      "Warrigal Road shops",
    ],
    nearbyStations: ["Oakleigh", "Huntingdale"],
    keywords: [
      "reformer pilates oakleigh",
      "pilates near oakleigh",
      "best pilates oakleigh",
      "oakleigh reformer studio",
      "pilates classes oakleigh",
    ],
  },
  {
    slug: "mount-waverley",
    suburb: "Mount Waverley",
    postcode: "3149",
    distanceKm: 4.5,
    driveMinutes: 10,
    intro:
      "Mount Waverley residents love that Passion Pilates is only a 10-minute drive away and offers something rarely found closer to the Monash Freeway — a genuinely boutique reformer studio with 9 beds and expert-led programming. If you've been searching for reformer Pilates near Mount Waverley, we're your closest boutique option.",
    localHooks: [
      "Direct route via Ferntree Gully Road → Chadstone",
      "Five class styles vs the single-format warehouses nearby",
      "Foundation Membership from $39/week locks in your rate for 12 months",
      "Beginner-friendly — Foundation Reformer runs every day",
    ],
    landmarks: [
      "The Glen Shopping Centre",
      "Mount Waverley Village",
      "Deakin University Burwood",
      "Monash Freeway",
    ],
    nearbyStations: ["Mount Waverley", "Syndal"],
    keywords: [
      "reformer pilates mount waverley",
      "pilates near mount waverley",
      "mount waverley pilates studio",
      "best reformer pilates mount waverley",
      "mt waverley pilates",
    ],
  },
  {
    slug: "carnegie",
    suburb: "Carnegie",
    postcode: "3163",
    distanceKm: 4.0,
    driveMinutes: 9,
    intro:
      "Carnegie is a nine-minute drive from Passion Pilates. If you're searching for the best reformer Pilates near Carnegie, you'll love our boutique format — small classes, five distinct styles, and $35 casual class rates instead of the $40+ you'll pay in the inner south.",
    localHooks: [
      "Nine minutes via Dandenong Road or North Road",
      "Popular with Monash University staff and postgrad students",
      "Student Foundation Membership from $35/week",
      "Evening 6:30pm Power Reformer perfect for after-work",
    ],
    landmarks: [
      "Koornang Road strip",
      "Carnegie Library",
      "Packer Park",
      "Carnegie Swim Centre",
    ],
    nearbyStations: ["Carnegie", "Murrumbeena"],
    keywords: [
      "reformer pilates carnegie",
      "pilates near carnegie",
      "carnegie pilates studio",
      "best pilates carnegie",
      "carnegie reformer",
    ],
  },
  {
    slug: "ashwood",
    suburb: "Ashwood",
    postcode: "3147",
    distanceKm: 3.5,
    driveMinutes: 8,
    intro:
      "Ashwood is our neighbour to the north-east — eight minutes down High Street Road. Passion Pilates is the closest boutique reformer studio to Ashwood, with brand-new equipment and small class caps for proper coaching.",
    localHooks: [
      "Eight minutes via High Street Road",
      "Family memberships available — book together, save together",
      "Six-days-a-week 6am and 6:30pm classes",
      "Free on-site parking, no meters",
    ],
    landmarks: [
      "Ashwood Reserve",
      "Deakin University",
      "PARC Aquatic",
      "High Street Road shops",
    ],
    nearbyStations: ["Jordanville", "Holmesglen"],
    keywords: [
      "reformer pilates ashwood",
      "pilates near ashwood",
      "ashwood pilates",
      "boutique reformer ashwood",
      "best pilates studio ashwood",
    ],
  },
  {
    slug: "ashburton",
    suburb: "Ashburton",
    postcode: "3147",
    distanceKm: 4.5,
    driveMinutes: 10,
    intro:
      "Ashburton residents are ten minutes from Passion Pilates via High Street Road. If you're weighing up reformer studios near Ashburton, we're the closest boutique — 9 beds, five class styles, and a coaching-first culture.",
    localHooks: [
      "Ten minutes via High Street Road",
      "Great for Ashburton commuters heading toward Chadstone SC",
      "Flow & Stretch class on the weekends — the recovery you're missing",
      "Members Portal for easy booking and referrals",
    ],
    landmarks: [
      "Ashburton Village",
      "Alamein Line terminus",
      "High Street Ashburton",
      "Ashburton Pool",
    ],
    nearbyStations: ["Ashburton", "Alamein"],
    keywords: [
      "reformer pilates ashburton",
      "pilates near ashburton",
      "ashburton pilates studio",
      "best pilates ashburton",
      "reformer studio ashburton",
    ],
  },
  {
    slug: "glen-iris",
    suburb: "Glen Iris",
    postcode: "3146",
    distanceKm: 5.5,
    driveMinutes: 12,
    intro:
      "Glen Iris is a twelve-minute drive down High Street Road to Passion Pilates. We're the closest boutique reformer studio to Glen Iris offering all five class styles — Foundation, Active, Strength, Power, and Flow & Stretch.",
    localHooks: [
      "Twelve minutes via High Street Road",
      "Popular with Glen Iris professionals doing our 6am and 7am Strength Reformer",
      "Foundation Membership from $39/week — cheaper than most Glen Iris and Malvern studios",
      "Seven-days-a-week schedule",
    ],
    landmarks: [
      "High Street Glen Iris",
      "Gardiner's Creek Trail",
      "Glen Iris Wetlands",
      "Malvern Valley Golf",
    ],
    nearbyStations: ["Glen Iris", "Darling"],
    keywords: [
      "reformer pilates glen iris",
      "pilates near glen iris",
      "glen iris reformer studio",
      "best pilates glen iris",
      "boutique pilates glen iris",
    ],
  },
  {
    slug: "camberwell",
    suburb: "Camberwell",
    postcode: "3124",
    distanceKm: 6.5,
    driveMinutes: 14,
    intro:
      "Camberwell locals can reach Passion Pilates in fourteen minutes down Toorak Road or Burke Road. If you want a genuinely boutique reformer Pilates studio near Camberwell without the $50+ casual class prices of the inner east, we're a short drive south.",
    localHooks: [
      "Fourteen minutes via Toorak or Burke Road",
      "$35 casual classes — significantly cheaper than Camberwell studios",
      "Foundation Membership from $39/week (Camberwell equivalents are $55–$65/week)",
      "9-bed boutique — smaller and more personal than most Camberwell warehouses",
    ],
    landmarks: [
      "Camberwell Junction",
      "Camberwell Fresh Food Market",
      "Rathmines Road strip",
      "Camberwell Sunday Market",
    ],
    nearbyStations: ["Camberwell", "Riversdale"],
    keywords: [
      "reformer pilates camberwell",
      "pilates near camberwell",
      "best pilates camberwell",
      "camberwell reformer studio",
      "boutique pilates camberwell",
    ],
  },
  {
    slug: "hughesdale",
    suburb: "Hughesdale",
    postcode: "3166",
    distanceKm: 2.5,
    driveMinutes: 6,
    intro:
      "Hughesdale is one of our closest neighbouring suburbs — a six-minute drive from Passion Pilates. If you want reformer Pilates near Hughesdale, we're the closest boutique studio with expert coaching.",
    localHooks: [
      "Six minutes via Poath or Warrigal Road",
      "Popular with Hughesdale train-line commuters",
      "6am Active Reformer beats the traffic",
      "10-Class Pack ($300) or 20-Class Pack — no lock-in",
    ],
    landmarks: [
      "Poath Road shops",
      "Hughesdale Station",
      "Hughesdale Primary",
      "Chadstone Shopping Centre",
    ],
    nearbyStations: ["Hughesdale", "Oakleigh"],
    keywords: [
      "reformer pilates hughesdale",
      "pilates near hughesdale",
      "hughesdale reformer",
      "pilates studio hughesdale",
      "best pilates hughesdale",
    ],
  },
  {
    slug: "murrumbeena",
    suburb: "Murrumbeena",
    postcode: "3163",
    distanceKm: 3.5,
    driveMinutes: 8,
    intro:
      "Murrumbeena is eight minutes down Neerim or Poath Road from Passion Pilates. Looking for reformer Pilates near Murrumbeena? We're the boutique studio locals recommend for beginner-friendly Foundation classes and Power Reformer at 6:30pm.",
    localHooks: [
      "Eight minutes via Neerim or Poath Road",
      "Popular with Murrumbeena parents — Mums & Bubs runs Tuesday & Thursday",
      "Family-friendly boutique culture",
      "Foundation Reformer daily for beginners",
    ],
    landmarks: [
      "Murrumbeena Park",
      "Murrumbeena Road shops",
      "Poath Road strip",
      "Duncan Mackinnon Reserve",
    ],
    nearbyStations: ["Murrumbeena", "Hughesdale"],
    keywords: [
      "reformer pilates murrumbeena",
      "pilates near murrumbeena",
      "murrumbeena pilates",
      "best pilates murrumbeena",
      "murrumbeena reformer",
    ],
  },
  {
    slug: "notting-hill",
    suburb: "Notting Hill",
    postcode: "3168",
    distanceKm: 5.5,
    driveMinutes: 11,
    intro:
      "Notting Hill locals — including Monash University staff and residents — can reach Passion Pilates in eleven minutes. We're the closest boutique reformer Pilates studio to Notting Hill with all five class styles seven days a week.",
    localHooks: [
      "Eleven minutes via Ferntree Gully Road",
      "Loved by Monash University staff",
      "Student Foundation Membership from $35/week",
      "Early 6am and late 6:30pm classes for shift workers",
    ],
    landmarks: [
      "Monash University Clayton",
      "Notting Hill Village",
      "Ferntree Gully Road",
      "Talbot Park",
    ],
    nearbyStations: ["Huntingdale", "Oakleigh"],
    keywords: [
      "reformer pilates notting hill",
      "pilates near notting hill",
      "notting hill pilates",
      "monash pilates",
      "pilates near monash uni",
    ],
  },
  {
    slug: "burwood",
    suburb: "Burwood",
    postcode: "3125",
    distanceKm: 5.0,
    driveMinutes: 11,
    intro:
      "Burwood residents are just eleven minutes from Passion Pilates via High Street or Burwood Highway. We're the closest boutique reformer studio to Burwood offering the full five-class curriculum and small-cap coaching.",
    localHooks: [
      "Eleven minutes via High Street Road",
      "Popular with Deakin students — $35/week Student Foundation Membership",
      "Corporate hire available for Burwood offices",
      "Foundation Reformer for absolute beginners every day",
    ],
    landmarks: [
      "Deakin University Burwood",
      "Burwood Highway",
      "Burwood One shops",
      "Wattle Park",
    ],
    nearbyStations: ["Blackburn", "Box Hill"],
    keywords: [
      "reformer pilates burwood",
      "pilates near burwood",
      "burwood pilates studio",
      "best pilates burwood",
      "deakin pilates",
    ],
  },
];

export const getNearbyBySlug = (slug) =>
  NEARBY_SUBURBS.find((s) => s.slug === slug);
